import i18n from 'i18n'

// Filter Constants
export const FILTER_ANY = ''
export const FILTER_NONE = '__NONE__'
export const FILTER_HAS_VALUE = '__HAS_VALUE__'

export const FILTER_YES = 'Yes'
export const FILTER_NO = 'No'

// Time Frames
export const DATE_FILTER_LAST_30 = 'LAST_30'
export const DATE_FILTER_LAST_MONTH = 'LAST_MONTH'
export const DATE_FILTER_THIS_MONTH = 'THIS_MONTH'
export const DATE_FILTER_NEXT_MONTH = 'NEXT_MONTH'
export const DATE_FILTER_LAST_3_MONTHS = 'LAST_3_MONTHS'
export const DATE_FILTER_NEXT_3_MONTHS = 'NEXT_3_MONTHS'
export const DATE_FILTER_LAST_6_MONTHS = 'LAST_6_MONTHS'
export const DATE_FILTER_NEXT_6_MONTHS = 'NEXT_6_MONTHS'
export const DATE_FILTER_LAST_QUARTER = 'LAST_QUARTER'
export const DATE_FILTER_THIS_QUARTER = 'THIS_QUARTER'
export const DATE_FILTER_NEXT_QUARTER = 'NEXT_QUARTER'
export const DATE_FILTER_LAST_7 = 'LAST_7'
export const DATE_FILTER_LAST_WEEK = 'LAST_WEEK'
export const DATE_FILTER_THIS_WEEK = 'THIS_WEEK'
export const DATE_FILTER_NEXT_WEEK = 'NEXT_WEEK'
export const DATE_FILTER_YESTERDAY = 'YESTERDAY'
export const DATE_FILTER_TODAY = 'TODAY'
export const DATE_FILTER_TOMORROW = 'TOMORROW'
export const DATE_FILTER_FUTURE = 'FUTURE'
export const DATE_FILTER_PAST = 'PAST'
export const DATE_FILTER_OLDER_THAN = 'OLDER_THAN'
export const DATE_FILTER_CUSTOM = 'CUSTOM'
export const DATE_FILTER_LAST_YEAR = 'LAST_YEAR'
export const DATE_FILTER_THIS_YEAR = 'THIS_YEAR'
export const DATE_FILTER_YEAR_TO_DATE = 'YEAR_TO_DATE'
export const DATE_FILTER_LAST_12_MONTHS = 'LAST_12_MONTHS'
export const DATE_FILTER_NEXT_12_MONTHS = 'NEXT_12_MONTHS'
export const DATE_FILTER_LAST_X_DAYS = 'LAST_X_DAYS'
export const DATE_FILTER_NEXT_X_DAYS = 'NEXT_X_DAYS'
export const DATE_FILTER_LAST_X_WEEKS = 'LAST_X_WEEKS'
export const DATE_FILTER_NEXT_X_WEEKS = 'NEXT_X_WEEKS'
export const DATE_FILTER_LAST_X_MONTHS = 'LAST_X_MONTHS'
export const DATE_FILTER_NEXT_X_MONTHS = 'NEXT_X_MONTHS'
export const DATE_FILTER_LAST_X_QUARTERS = 'LAST_X_QUARTERS'
export const DATE_FILTER_NEXT_X_QUARTERS = 'NEXT_X_QUARTERS'
export const DATE_FILTER_LAST_X_YEARS = 'LAST_X_YEARS'
export const DATE_FILTER_NEXT_X_YEARS = 'NEXT_X_YEARS'
export const PROBABILITY_FILTER = 'PROBABILITY_FILTER'

export const getDateFilters = () => ({
  [DATE_FILTER_LAST_30]: i18n.t('dateFilters.last30Days'),
  [DATE_FILTER_LAST_MONTH]: i18n.t('dateFilters.lastMonth'),
  [DATE_FILTER_THIS_MONTH]: i18n.t('dateFilters.thisMonth'),
  [DATE_FILTER_NEXT_MONTH]: i18n.t('dateFilters.nextMonth'),
  [DATE_FILTER_LAST_3_MONTHS]: i18n.t('dateFilters.last3Months'),
  [DATE_FILTER_NEXT_3_MONTHS]: i18n.t('dateFilters.next3Months'),
  [DATE_FILTER_LAST_6_MONTHS]: i18n.t('dateFilters.last6Months'),
  [DATE_FILTER_NEXT_6_MONTHS]: i18n.t('dateFilters.next6Months'),
  [DATE_FILTER_LAST_QUARTER]: i18n.t('dateFilters.lastQuarter'),
  [DATE_FILTER_THIS_QUARTER]: i18n.t('dateFilters.thisQuarter'),
  [DATE_FILTER_NEXT_QUARTER]: i18n.t('dateFilters.nextQuarter'),
  [DATE_FILTER_LAST_7]: i18n.t('dateFilters.last7Days'),
  [DATE_FILTER_LAST_WEEK]: i18n.t('dateFilters.lastWeek'),
  [DATE_FILTER_THIS_WEEK]: i18n.t('dateFilters.thisWeek'),
  [DATE_FILTER_NEXT_WEEK]: i18n.t('dateFilters.nextWeek'),
  [DATE_FILTER_YESTERDAY]: i18n.t('dateFilters.yesterday'),
  [DATE_FILTER_TODAY]: i18n.t('dateFilters.today'),
  [DATE_FILTER_TOMORROW]: i18n.t('dateFilters.tomorrow'),
  [DATE_FILTER_FUTURE]: i18n.t('dateFilters.future'),
  [DATE_FILTER_PAST]: i18n.t('dateFilters.past'),
  [DATE_FILTER_OLDER_THAN]: i18n.t('dateFilters.olderThan'),
  [DATE_FILTER_CUSTOM]: i18n.t('dateFilters.custom'),
  [DATE_FILTER_LAST_YEAR]: i18n.t('dateFilters.lastYear'),
  [DATE_FILTER_THIS_YEAR]: i18n.t('dateFilters.thisYear'),
  [DATE_FILTER_YEAR_TO_DATE]: i18n.t('dateFilters.yearToDate'),
  [DATE_FILTER_LAST_12_MONTHS]: i18n.t('dateFilters.last12Months'),
  [DATE_FILTER_NEXT_12_MONTHS]: i18n.t('dateFilters.next12Months'),
  [DATE_FILTER_LAST_X_DAYS]: i18n.t('dateFilters.lastXDays'),
  [DATE_FILTER_NEXT_X_DAYS]: i18n.t('dateFilters.nextXDays'),
  [DATE_FILTER_LAST_X_WEEKS]: i18n.t('dateFilters.lastXWeeks'),
  [DATE_FILTER_NEXT_X_WEEKS]: i18n.t('dateFilters.nextXWeeks'),
  [DATE_FILTER_LAST_X_MONTHS]: i18n.t('dateFilters.lastXMonths'),
  [DATE_FILTER_NEXT_X_MONTHS]: i18n.t('dateFilters.nextXMonths'),
  [DATE_FILTER_LAST_X_QUARTERS]: i18n.t('dateFilters.lastXQuarters'),
  [DATE_FILTER_NEXT_X_QUARTERS]: i18n.t('dateFilters.nextXQuarters'),
  [DATE_FILTER_LAST_X_YEARS]: i18n.t('dateFilters.lastXYears'),
  [DATE_FILTER_NEXT_X_YEARS]: i18n.t('dateFilters.nextXYears')
})

// Legacy export for backwards compatibility
export const DATE_FILTERS = {
  [DATE_FILTER_LAST_30]: 'Last 30 Days',
  [DATE_FILTER_LAST_MONTH]: 'Last Month',
  [DATE_FILTER_THIS_MONTH]: 'This Month',
  [DATE_FILTER_NEXT_MONTH]: 'Next Month',
  [DATE_FILTER_LAST_3_MONTHS]: 'Last 3 Months',
  [DATE_FILTER_NEXT_3_MONTHS]: 'Next 3 Months',
  [DATE_FILTER_LAST_6_MONTHS]: 'Last 6 Months',
  [DATE_FILTER_NEXT_6_MONTHS]: 'Next 6 Months',
  [DATE_FILTER_LAST_QUARTER]: 'Last Quarter',
  [DATE_FILTER_THIS_QUARTER]: 'This Quarter',
  [DATE_FILTER_NEXT_QUARTER]: 'Next Quarter',
  [DATE_FILTER_LAST_7]: 'Last 7 Days',
  [DATE_FILTER_LAST_WEEK]: 'Last Week',
  [DATE_FILTER_THIS_WEEK]: 'This Week',
  [DATE_FILTER_NEXT_WEEK]: 'Next Week',
  [DATE_FILTER_YESTERDAY]: 'Yesterday',
  [DATE_FILTER_TODAY]: 'Today',
  [DATE_FILTER_TOMORROW]: 'Tomorrow',
  [DATE_FILTER_FUTURE]: 'Future',
  [DATE_FILTER_PAST]: 'Past',
  [DATE_FILTER_OLDER_THAN]: 'Older Than',
  [DATE_FILTER_CUSTOM]: 'Custom',
  [DATE_FILTER_LAST_YEAR]: 'Last Year',
  [DATE_FILTER_THIS_YEAR]: 'This Year',
  [DATE_FILTER_YEAR_TO_DATE]: 'Year to Date',
  [DATE_FILTER_LAST_12_MONTHS]: 'Last 12 Months',
  [DATE_FILTER_NEXT_12_MONTHS]: 'Next 12 Months',
  [DATE_FILTER_LAST_X_DAYS]: 'Last X Days',
  [DATE_FILTER_NEXT_X_DAYS]: 'Next X Days',
  [DATE_FILTER_LAST_X_WEEKS]: 'Last X Weeks',
  [DATE_FILTER_NEXT_X_WEEKS]: 'Next X Weeks',
  [DATE_FILTER_LAST_X_MONTHS]: 'Last X Months',
  [DATE_FILTER_NEXT_X_MONTHS]: 'Next X Months',
  [DATE_FILTER_LAST_X_QUARTERS]: 'Last X Quarters',
  [DATE_FILTER_NEXT_X_QUARTERS]: 'Next X Quarters',
  [DATE_FILTER_LAST_X_YEARS]: 'Last X Years',
  [DATE_FILTER_NEXT_X_YEARS]: 'Next X Years'
}

// Dynamic filter constants that use a numeric input
export const DYNAMIC_DATE_FILTERS = [
  DATE_FILTER_LAST_X_DAYS, DATE_FILTER_NEXT_X_DAYS,
  DATE_FILTER_LAST_X_WEEKS, DATE_FILTER_NEXT_X_WEEKS,
  DATE_FILTER_LAST_X_MONTHS, DATE_FILTER_NEXT_X_MONTHS,
  DATE_FILTER_LAST_X_QUARTERS, DATE_FILTER_NEXT_X_QUARTERS,
  DATE_FILTER_LAST_X_YEARS, DATE_FILTER_NEXT_X_YEARS
]

// Unit labels for dynamic filters
export const DYNAMIC_FILTER_UNITS = {
  [DATE_FILTER_LAST_X_DAYS]: 'days',
  [DATE_FILTER_NEXT_X_DAYS]: 'days',
  [DATE_FILTER_LAST_X_WEEKS]: 'weeks',
  [DATE_FILTER_NEXT_X_WEEKS]: 'weeks',
  [DATE_FILTER_LAST_X_MONTHS]: 'months',
  [DATE_FILTER_NEXT_X_MONTHS]: 'months',
  [DATE_FILTER_LAST_X_QUARTERS]: 'quarters',
  [DATE_FILTER_NEXT_X_QUARTERS]: 'quarters',
  [DATE_FILTER_LAST_X_YEARS]: 'years',
  [DATE_FILTER_NEXT_X_YEARS]: 'years'
}

// Map legacy hardcoded filters to their dynamic equivalents
const LEGACY_TO_DYNAMIC = {
  LAST_7: { selection: DATE_FILTER_LAST_X_DAYS, duration: 7 },
  LAST_30: { selection: DATE_FILTER_LAST_X_DAYS, duration: 30 },
  NEXT_7: { selection: DATE_FILTER_NEXT_X_DAYS, duration: 7 },
  NEXT_30: { selection: DATE_FILTER_NEXT_X_DAYS, duration: 30 },
  LAST_60: { selection: DATE_FILTER_LAST_X_DAYS, duration: 60 },
  NEXT_60: { selection: DATE_FILTER_NEXT_X_DAYS, duration: 60 },
  LAST_90: { selection: DATE_FILTER_LAST_X_DAYS, duration: 90 },
  NEXT_90: { selection: DATE_FILTER_NEXT_X_DAYS, duration: 90 },
  LAST_3_MONTHS: { selection: DATE_FILTER_LAST_X_MONTHS, duration: 3 },
  NEXT_3_MONTHS: { selection: DATE_FILTER_NEXT_X_MONTHS, duration: 3 },
  LAST_6_MONTHS: { selection: DATE_FILTER_LAST_X_MONTHS, duration: 6 },
  NEXT_6_MONTHS: { selection: DATE_FILTER_NEXT_X_MONTHS, duration: 6 },
  LAST_12_MONTHS: { selection: DATE_FILTER_LAST_X_MONTHS, duration: 12 },
  NEXT_12_MONTHS: { selection: DATE_FILTER_NEXT_X_MONTHS, duration: 12 }
}

// Convert legacy saved filter values to dynamic format for display
export const normalizeOldDateFilter = (value) => {
  if (!value || !value.selection) return value
  const mapped = LEGACY_TO_DYNAMIC[value.selection.toUpperCase()]
  if (mapped) {
    return { ...value, selection: mapped.selection, duration: value.duration || mapped.duration }
  }
  return value
}
